import {
  Box,
  Divider,
  Typography
} from '@mui/material';
import TextField from '@mui/material/TextField';
import React from 'react';
import {SupportTicketModel} from '../../../../model/support/support-ticket.model';
import {SupportTicketUtils} from '../utils/support-ticket.utils';
import { Link } from '@mui/material';

type Props = {
  ticket: SupportTicketModel
  setTicket: (ticket: SupportTicketModel) => void
  translate: (key: string) => string
  translateLocal: (key: string) => string
  isDisabled: boolean
}

export const SupportTicketDrawerFixedScheduled = ({ticket, setTicket, isDisabled, translate, translateLocal}: Props) => {
  const buildHeader = () => (
    <Box mt={1} pt={1}>
      <Box display="flex" alignItems="center" ml={0.5} mb={0.5}>
        {SupportTicketUtils.getResolutionIcon(ticket.resolution) && (
          <Box
            mr={0.5}
            color={SupportTicketUtils.getResolutionIconColor(ticket.resolution)}
            display="flex"
            alignItems="center"
          >
            {React.createElement(SupportTicketUtils.getResolutionIcon(ticket.resolution), { fontSize: "small" })}
          </Box>
        )}
        <Typography variant="body1" fontWeight={600} letterSpacing={1} mr={1} lineHeight={1}>
          Utwórz zgłoszenie w jira i wklej link poniżej:
        </Typography>
        <Typography variant="body1" fontWeight={600} letterSpacing={1} mr={1} lineHeight={1}>
          <Link href="https://smartvendor.atlassian.net/browse/SVM-106" target="_blank" rel="noopener">
            Kliknij tutaj
          </Link>
        </Typography>
      </Box>
    </Box>
  );

  const buildJiraLink = () => <Box mt={2}>
    <TextField
      label={'Link do zgloszenia w Jira'}
      value={ticket.jiraTicket}
      disabled={isDisabled}
      onChange={(e) => setTicket({...ticket, jiraTicket: e.target.value})}
      required
      fullWidth
    />
  </Box>

  const buildEstimatedFixDate = () => (
    <Box mt={2} mb={2}>
      <TextField
        label="Estymowana data naprawy"
        type="date"
        disabled={isDisabled}
        value={ticket.estimatedFixDate || ''}
        onChange={(e) => setTicket({ ...ticket, estimatedFixDate: e.target.value })}
        required
        fullWidth
        InputLabelProps={{
          shrink: true,
        }}
      />
    </Box>
  );

  return <>
    {buildHeader()}
    {buildJiraLink()}
    {buildEstimatedFixDate()}
  </>
}